import { FaChartLine } from 'react-icons/fa';

export function StatsIcon({ className }: { className?: string }) {
  return <FaChartLine className={`text-[1rem] text-[#FBBF24] ${className}`} />;
}
